export default "__VITE_ASSET__Bbczp19K__"